import { UserStatus } from "@bvhi/backend-api";
import { Box, Chip } from "@bvhi/ui-base";
import { UserStatusChip } from "../../../components/common/user-status-chip";

interface Props {
  data?: UserStatus;
  hasLoggedIn?: boolean;
}

export const UserStatusCell = ({ data, hasLoggedIn }: Props) => {
  if (!data)
    return (
      <Box>
        <Chip label="Keine Auswahl" />
      </Box>
    );

  return (
    <Box>
      <UserStatusChip hasLoggedIn={hasLoggedIn} size="medium" status={data} />
    </Box>
  );
};
